// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__163Mn","title":"Info_title__6jSht","links":"Info_links__3JJ4U","link":"Info_link__NjTP8","logo":"Info_logo__gCiz4"};